/**
 * API helper — общая обёртка над fetch с credentials: include.
 */
async function apiRequest(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!res.ok) {
    let errorMessage = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      errorMessage = data.detail || data.message || errorMessage;
    } catch {}
    throw new Error(errorMessage);
  }

  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  get: (url) => apiRequest(url),
  post: (url, body) => apiRequest(url, { method: 'POST', body: JSON.stringify(body) }),
  put: (url, body) => apiRequest(url, { method: 'PUT', body: JSON.stringify(body) }),
  delete: (url) => apiRequest(url, { method: 'DELETE' }),
};

// ─── Invites ────────────────────────────────────────────────────────────
export const invitesService = {
  check: (token) => api.get(`/api/cabinet/invite/${token}`),
  accept: (token, password, privacy_consent = true) =>
    api.post(`/api/cabinet/invite/${token}/accept`, { password, privacy_consent }),
};

// ─── Students / Balances / Transactions / Payments ──────────────────────
export const cabinetService = {
  // Дети текущего родителя — берём из /api/students (фильтрация по PARENT на бэкенде)
  getMyStudents: () => api.get('/api/students?include_inactive=false'),

  getBalance: (studentId) => api.get(`/api/students/${studentId}/balance`),
  getTransactions: (studentId, limit = 100) =>
    api.get(`/api/students/${studentId}/transactions?limit=${limit}`),

  // Создание платежа
  createTopup: (studentId, payload) =>
    api.post(`/api/students/${studentId}/payments/topup`, payload),

  // Список платежей ученика
  getPayments: (studentId) => api.get(`/api/students/${studentId}/payments`),

  // Ближайшие занятия ученика
  getUpcomingLessons: (studentId, limit = 4) =>
    api.get(`/api/students/${studentId}/upcoming-lessons?limit=${limit}`),

  // Пресеты пополнения баланса (с учётом семейной скидки)
  getPaymentPresets: (studentId) =>
    api.get(`/api/students/${studentId}/payments/presets`),

  // Соревнования
  getActiveCompetitions: () =>
    api.get('/api/cabinet/competitions/active'),
  registerForCompetition: (competitionId, payload) =>
    api.post(`/api/cabinet/competitions/${competitionId}/register`, payload),
  registerNewForCompetition: (competitionId, payload) =>
    api.post(`/api/cabinet/competitions/${competitionId}/register-new`, payload),
  payCompetition: (competitionId, participantId) =>
    api.post(`/api/cabinet/competitions/${competitionId}/participants/${participantId}/pay`, {}),

  // Статус доступности оплат (test/live mode)
  getPaymentMode: () => api.get('/api/cabinet/payment-mode'),
};
